<div class="select-files-content">
    <core-files-selected-box
        [title]="'Your selected file' + (files.length > 1 ? 's':'')"
        [files]="files"
        (onFileActionClick)="onRemove($event)"
    ></core-files-selected-box>
    <h4 class="h4_subtitle">Select the file(s) to request feedback from the list below</h4>

    <core-versions-related-selector
      [project]="project ?? partialProject"
      [selected]="files"
      (selectedChange)="onChange($event);"
      [disabled]="false"
    ></core-versions-related-selector>
    
    <core-version-origin-version-files-list-checkbox *ngIf="project != null"
      [request]="project"
      [selected]="files"
      (selectedChange)="onChange($event);"
      [disabled]="false"
    ></core-version-origin-version-files-list-checkbox>

  </div>
